// extracted by mini-css-extract-plugin
export default {"content":"AgentFetch_content__4TOd7"};